export default "/images/7cbdd0c3e938c9a99b563a1ef875389d.avif";